import { Component, OnInit, ViewChild, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AdminImageService } from 'src/app/admin/services/admin-image.service';
import { PageUrls } from 'src/app/helpers/page-urls';
import { AppUtils } from 'src/app/helpers/app.utils';
import { TableModel } from 'src/app/models/table.model';
import { ImageFilterModel } from 'src/app/admin/models/image.filter.model';
import { PagedImageGroupeByFolderDetails } from 'src/app/admin/models/paged.image.groupe.by.folder';

@Component({
    selector: 'app-image-folder-view',
    templateUrl: './image.folder.view.component.html',
    styleUrls: ['./image.folder.view.component.scss']
})

export class ImageFolderViewComponent implements OnInit, OnDestroy {
    @ViewChild('imageApproveMultiple', { static: false }) imageApproveMultipleModal: any;
    @Input() imageFilterModel: ImageFilterModel;
    @Input() tableModel: TableModel;
    @Output() openImageView = new EventEmitter();
    subscriptions = new Array<Subscription>();
    pagedImageGroupeByFolderDetails = new PagedImageGroupeByFolderDetails();
    totalRecords = 0;
    isModelLoaded = false;
    selectedAll = false;

    constructor(private router: Router,
        private route: ActivatedRoute,
        private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private adminImageService: AdminImageService) { }

    ngOnInit() {
        if (this.route.snapshot.queryParams.status
            && Number(this.route.snapshot.queryParams.status) !== NaN) {
            this.imageFilterModel.status = Number(this.route.snapshot.queryParams.status);
        }
        if (this.route.snapshot.queryParams.photographer) {
            this.imageFilterModel.photographer = this.route.snapshot.queryParams.photographer;
        }

        this.tableModel.orderBy = '';
        this.tableModel.orderByDirection = '';

        this.initSubscribers();
        this.getFolders();

    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getFolders());
        this.subscriptions.push(subscription);
    }

    getSelectedImageIdList() {
        const selectedImages = (this.pagedImageGroupeByFolderDetails.items
            .filter(x => x.isSelected === true).map((item) => item.imageIdList));
        const selectedImageIdList = new Array<number>();
        selectedImages.forEach(imageArr => {
            imageArr.forEach(imageId => {
                selectedImageIdList.push(imageId);
            });
        });
        if (selectedImageIdList.length === 0) {
            this.toastr.error('Please select an image to continue');
            return;
        }
        return selectedImageIdList;
    }

    getFolders = () => {
        this.isModelLoaded = false;
        this.ngxSpinnerService.show();
        this.adminImageService.getListGroupByFolder(this.imageFilterModel, this.tableModel)
            .subscribe(data => {
                this.pagedImageGroupeByFolderDetails = data;
                this.selectedAll = false;
                this.totalRecords = data.totalCount;
                this.ngxSpinnerService.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    reloadImages(resetPagination: boolean) {
        if (resetPagination) {
            this.tableModel.page = 1;
        }
        this.getFolders();
    }

    openImageDetail(imageId: number) {
        let returnParams = `url=${PageUrls.Admin.ImageManage}&`;
        returnParams += `status=${this.imageFilterModel.status}&`;
        returnParams += `photographer=${this.imageFilterModel.photographer}`;
        this.router.navigateByUrl(
            `${PageUrls.Admin.UpdateImage}?imageId=${imageId}&${returnParams}`);
    }

    selectAll() {
        this.pagedImageGroupeByFolderDetails.items.forEach(image => {
            image.isSelected = this.selectedAll;
        });
    }

    updateSelectAll() {
        const selectedImages = this.pagedImageGroupeByFolderDetails.items.filter(x => x.isSelected);
        if (selectedImages.length !== this.pagedImageGroupeByFolderDetails.items.length) {
            this.selectedAll = false;
        } else {
            this.selectedAll = true;
        }
    }

    imageView(photographerId: string, folderName: string) {
        this.imageFilterModel.folderName = folderName;
        this.openImageView.next(photographerId);
    }

    viewAllFolders() {
        this.tableModel.pageSize = this.totalRecords;
        this.getFolders();
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
    }
}
